import { createRouter, createWebHistory } from 'vue-router'
import LoadingView from '../views/LoadingView.vue'

const routes = [
  {
    path: '/shared',
    name: 'shared',
    component: () => import('../views/ShareLoader.vue')
  },
  {
    path: '/:cid/:uKeyId',
    name: 'loaderAppKey',
    component: LoadingView
  },
  {
    path: '/:cid',
    name: 'loaderApp',
    component: LoadingView
  },
  {
    path: '/m',
    name: 'main',
    component: () => import('../views/MainView.vue')
  },
  {
    path: '/',
    name: 'loader',
    component: LoadingView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
